import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import { appLocales, appStrings, formats } from '../localization';
import { generateRoutes } from '../utils';

const baseRoutes = generateRoutes();
const { en: defaultLocale } = appLocales;

/**
 * LocalizedRouter has 3 routes
 * 1 - Catches any routes of two characters expecting a locale i.e /en or /fr
 * 2 - The base route '/' will redirect user to the login page of default locale
 * 3 - Catch all which redirects the user to 404 not found page but before redirecting the user,
 * we check to see if the route entered matches one of the routes where the locale is known.
 * i.e /login -> en/login, ouvrir-une-session -> fr/ouvrir-une-session
 * If a match is found, we redirect the user to the route with the locale.
 */

const LocalizedRouter = ({ children }) => (
    <BrowserRouter>
        <Switch>
            <Route path="/:locale([a-zA-Z]{2})">
                {({ match }) => {
                    const { params } = match;
                    let { locale } = params;
                    locale = locale.toLowerCase();
                    const localeAppStrings = appStrings[locale];

                    if (!localeAppStrings) {
                        return <Redirect to={`/${defaultLocale}/404`} />;
                    }

                    return (
                        <IntlProvider
                            defaultFormats={formats}
                            formats={formats}
                            locale={locale}
                            messages={localeAppStrings}
                        >
                            {children}
                        </IntlProvider>
                    );
                }}
            </Route>
            <Route exact path="/">
                <Redirect to={`/${defaultLocale}/`} />
            </Route>
            <Route path="*">
                {({ match }) => {
                    const { url } = match;
                    const locale = baseRoutes[url];
                    return locale ? <Redirect to={`/${locale}` + url} /> : <Redirect to={`/${defaultLocale}/404`} />;
                }}
            </Route>
        </Switch>
    </BrowserRouter>
);

export { LocalizedRouter as BrowserRouter };
